var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "half-circle-spinner", style: _vm.spinnerStyle },
    [
      _c("div", { staticClass: "circle circle-1", style: _vm.circle1Style }),
      _vm._v(" "),
      _c("div", { staticClass: "circle circle-2", style: _vm.circle2Style })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }